export const LOCAL_STORE_NAME = "csv_explorer"
export const LOCAL_STORE_QUERY_KEY = "query"
export const LOCAL_STORE_SQLITE_KEY = "sqlite"
